import React, {FormEvent, useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {login} from "../helper/CMSApi";

const LoginPage: React.FC = () => {
    const [identifier, setIdentifier] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [error, setError] = useState<string>('');

    const navigate = useNavigate();
    const isAuthenticated = !!localStorage.getItem("authToken");

    useEffect(() => {
        if (isAuthenticated) {
            navigate("/", { replace: true });
        }
    }, [isAuthenticated, navigate]);

    const handleLogin = async (e: FormEvent) => {
        e.preventDefault();

        try {
            const data = await login(identifier, password)
            localStorage.setItem('authToken', data.jwt);
            localStorage.setItem('user', JSON.stringify(data.user));
            navigate('/');
        } catch (err) {
            console.error('Login error:', err);
            setError('An unexpected error occurred. Please try again.');
        }
    };

    return (
        <div className="w-screen h-screen">
            <div className="max-w-xl my-auto mx-auto">
                <form onSubmit={handleLogin}>
                    <div>
                        <input
                            type="text"
                            placeholder="Email or Username"
                            value={identifier}
                            className="bg-gray-700 text-white border border-gray-600 rounded px-3 py-2 w-full"
                            onChange={(e) => setIdentifier(e.target.value)}
                        />
                    </div>
                    <div style={{marginTop: '10px'}}>
                        <input
                            type="password"
                            placeholder="Password"
                            value={password}
                            className="bg-gray-700 text-white border border-gray-600 rounded px-3 py-2 w-full"
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <div style={{marginTop: '15px'}}>
                        <button type="submit"
                                className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded">Log
                            In
                        </button>
                    </div>
                </form>
                {error && <p style={{color: 'red'}}>{error}</p>}
            </div>

        </div>
    );
};

export default LoginPage;
